import ChangePassword from '../../components/Auth/ChangePassword';
import './styles.scss';

const ChangePasswordPage = (props: any) => {
    return <ChangePassword />
  }
  
  export default ChangePasswordPage;